import * as React from "react";
import FileManager from '../FileManager/FileManager';
import { BaseFieldProps } from './types';
import { PureStringField } from './Pure/PureStringField';
import { DefaultButton, PrimaryButton } from 'office-ui-fabric-react';
import { validateUrl } from "app/shared/functions";
import { getFilePath } from "app/utils/service";

interface FileFieldState {
    fileManagerActive: boolean;
}

export default class FileField extends React.Component<
    BaseFieldProps,
    FileFieldState
> {
    constructor(props: BaseFieldProps) {
        super(props);
        this.state = {
            fileManagerActive: false
        };
    }

    render() {
        if (this.props.property.conditionalHide && this.props.property.conditionalHide(this.props)) return null;
        const file = this.props.value;
        const source = validateUrl(file) ? file : (getFilePath() + file);

        return (
            <React.Fragment>
                <FileManager
                    activeFile={this.props.value}
                    onSelectedFile={(file) => {
                        this.props.onChange(file.fileName)
                    }}
                    show={this.state.fileManagerActive}
                    onDismiss={() => {
                        this.setState({
                            fileManagerActive: false
                        })
                    }}
                />
                <div className="row">
                    <PureStringField
                        label={this.props.property.name}
                        text={this.props.property.text as string}
                        description={this.props.property.description as string}
                        value={this.props.value}
                        onChange={value => this.props.onChange(value)}
                        className="image-field"
                        customRender={() => {
                            return (
                                <div style={{ marginLeft: "auto" }} className="row">
                                    <DefaultButton
                                        className="custom-button"
                                        text="Görüntüle"
                                        style={{ marginTop: 2.5 }}
                                        disabled={!this.props.value}
                                        onClick={() => {
                                            window.open(source, "_blank")
                                        }}
                                    />
                                    <PrimaryButton
                                        className="custom-button"
                                        text="Dosya Seç"
                                        style={{ marginTop: 2.5 }}
                                        onClick={() => {
                                            this.setState({
                                                fileManagerActive: true
                                            }, () => {
                                                document.querySelector(".external-panel")?.classList.add("fade");
                                            });
                                        }}
                                    />
                                </div>
                            )
                        }}
                    />
                </div>
            </React.Fragment>
        );
    }
}
